import Engine from '@/api/engine.api.js'

/*eslint-disable */
export const getEngine = ({ commit }, data) => {
  return Engine.getEngine(data)
    .then(response => {
      commit("SET_ENGINES", response.data)
      return response.data;
    })
}
/*eslint-enable */
